<div class="relative h-screen flex flex-col bg-dashboard-bg selection:bg-blue-500/30">
  <!-- Shift Transition Overlay -->
  @if (stateService.isShiftChanging()) {
  <div class="fixed inset-0 z-[100]">
    <app-shift-announcement></app-shift-announcement>
  </div>
  }

  <main class="flex-1 relative flex flex-col">
    <!-- Shift Badge -->
    <div class="absolute top-4 right-8 z-10">
      <div class="bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20 flex items-center gap-3">
        <span class="text-white font-tech tracking-widest text-sm uppercase">
          Grupo {{ stateService.currentGroup() }}
        </span>
        @if (isOffline()) {
        <span class="text-red-400 text-xs uppercase tracking-wider font-bold">
          ● OFFLINE
        </span>
        } @else if (stateService.lastUpdated()) {
        <span class="text-white/50 text-xs">
          {{ stateService.lastUpdated() | date:'HH:mm:ss' }}
        </span>
        }
      </div>
    </div>

    <!-- View Container -->
    <div class="flex-1 w-screen overflow-hidden max-h-[calc(100vh-4.25rem)]">
      @switch (rotationService.currentViewIndex()) {
      @case (0) { <app-current-customers /> }
      @case (1) { <app-work-orders-progress /> }
      @case (2) { <app-closed-knitting-orders /> }
      @case (3) { <app-knitting-order-progress /> }
      @case (4) { <app-rejected-knitting-orders /> }
      @case (5) { <app-machine-production-rate /> }
      @case (6) { <app-shift-announcement [rotationProgress]="rotationService.progress()"></app-shift-announcement> }
      @case (7) { <app-rejected-machines /> }
      }
    </div>

    <!-- Cycle Progress Bar -->
    @if (!stateService.isShiftChanging()) {
    <div class="w-full h-4 bg-white/5 overflow-hidden z-50">
      <div class="h-full bg-white" [style.width.%]="rotationService.progress()"></div>
    </div>
    }
  </main>

  @if (!isProduction) {
  <app-dev-view-switcher />
  }

  <!-- Footer -->
  <footer
    class="w-full bg-black/40 backdrop-blur-sm border-t border-white/10 px-6 py-3 flex items-center justify-between">
    <div class="text-white/70 text-xs sm:text-sm font-light tracking-wide">
      <div class="flex items-center gap-2">
        <span>{{ currentDateTime() | date:'dd/MM/yyyy' }}</span>
        <span class="text-white/40">•</span>
        <span>{{ currentDateTime() | date:'HH:mm:ss' }}</span>
        @if (stateService.lastUpdated()) {
        <span class="text-white/40">•</span>
        <span class="text-white/50 uppercase tracking-widest text-[10px] sm:text-xs">
          Last fetch {{ stateService.lastUpdated() | date:'HH:mm:ss' }}
        </span>
        }
      </div>
    </div>
    <img src="https://sierra-erp-assets.s3.us-east-1.amazonaws.com/sierra_nexus/SIERRA_Nexus_White.svg"
      alt="Sierra Nexus Logo" class="h-6 sm:h-8" />
  </footer>
</div>